module.exports = __webpack_public_path__ + "img/background.00ab1806.svg";